import { isObjectRecord } from "../../typeGuards";
import { ArsTableCellType, ArsTableRowGroupLabel } from "../interface";
import { isArsTableCellBase } from "./isArsTableCellBase";

/**
 * Type guard for ArsTableRowGroupCell, which is a possible type of ArsTableCellBase.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableRowGroupCell, false otherwise
 */
export const isArsTableRowGroupLabel = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableRowGroupLabel<T> => {
  if (!isObjectRecord(obj)) return false;
  if (!isArsTableCellBase<T>(obj, isT)) return false;

  if (obj.cellType !== ArsTableCellType.RowGroupLabel) return false;
  if (!["number", "undefined"].includes(typeof obj.colSpan)) return false;
  if (!["number", "undefined"].includes(typeof obj.height)) return false;
  if (!["number", "undefined"].includes(typeof obj.rowSpan)) return false;
  if (typeof obj.siblingCount !== "number") return false;
  if (typeof obj.targetId !== "string") return false;
  if (typeof obj.targetType !== "string" || !["dataDriven", "group"].includes(obj.targetType))
    return false;

  // Everything is good
  return true;
};
